import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_josmart-staging/artifacts/99w30619_1000023965.png";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#0B1521]" data-testid="privacy-page">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#152840] rounded-2xl p-8 md:p-12 border border-white/10">
            <h1 className="text-3xl font-bold text-white mb-8">Politique de Confidentialité</h1>
            
            <div className="prose prose-invert max-w-none space-y-6 text-white/80">
              <p className="text-lg">
                Dernière mise à jour : Janvier 2026
              </p>

              <section>
                <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Introduction</h2>
                <p>
                  JoSmart ("nous", "notre", "nos") s'engage à protéger la vie privée des utilisateurs de nos applications et services. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations personnelles.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Informations collectées</h2>
                <p>Nous collectons les types d'informations suivants :</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Informations d'inscription (nom, email, mot de passe)</li>
                  <li>Informations de profil (photo, bio)</li>
                  <li>Messages et contenus partagés</li>
                  <li>Données d'utilisation et analytics</li>
                  <li>Informations de contact fournies via nos formulaires</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Utilisation des données</h2>
                <p>Vos données sont utilisées pour :</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Fournir et améliorer nos services</li>
                  <li>Personnaliser votre expérience</li>
                  <li>Communiquer avec vous concernant nos services</li>
                  <li>Assurer la sécurité de nos plateformes</li>
                  <li>Respecter nos obligations légales</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Protection des données</h2>
                <p>
                  Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données contre tout accès, modification, divulgation ou destruction non autorisés.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Partage des données</h2>
                <p>
                  Nous ne vendons pas vos données personnelles. Nous pouvons partager vos informations uniquement dans les cas suivants :
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Avec votre consentement explicite</li>
                  <li>Pour répondre à des obligations légales</li>
                  <li>Avec nos prestataires de services sous contrat de confidentialité</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Vos droits</h2>
                <p>Vous disposez des droits suivants concernant vos données :</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Droit d'accès à vos données</li>
                  <li>Droit de rectification</li>
                  <li>Droit à l'effacement</li>
                  <li>Droit à la portabilité</li>
                  <li>Droit d'opposition</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Contact</h2>
                <p>
                  Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, contactez-nous :
                </p>
                <ul className="list-none space-y-2 mt-4">
                  <li>Email : contactjosmart1@gmail.com</li>
                  <li>WhatsApp : +14313345083</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. Modifications</h2>
                <p>
                  Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications prendront effet dès leur publication sur cette page.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
